import { ChatUserInfo } from "@xapp/stentor-chat-widget";
import { visitorFingerprint } from "../utils/fingerprint";
import { ChatState } from "./ChatState";

const DEFAULT_VISITOR: ChatUserInfo = {
    displayName: "Visitor",
    nick: "visitor:",
    typing: false
};

export function createDefaultState(state?: Partial<ChatState>): ChatState {

    if (!state) {
        state = {};
    }

    state.userId = state.userId ? state.userId : visitorFingerprint();
    state.visitorId = state.userId;

    return {
        connection: {
            connectionStatus: "offline",
            token: null,
            greetingRequested: false
        },
        accountStatus: "offline",
        departments: {},
        visitor: DEFAULT_VISITOR,
        agents: {},
        chats: [],
        lastTimestamp: 0,
        lastRatingRequestTimestamp: 0,
        hasRating: false,
        isChatting: false,
        queuePosition: 0,
        failureMsg: null,
        visitorId: visitorFingerprint(),
        chips: [],
        sessionExpiration: "24h",
        visuals: {},
        ...state
    };
}

export const DEFAULT_STATE: ChatState = createDefaultState();